import { render, staticRenderFns } from "./fontsDialog.vue?vue&type=template&id=4de79b12&scoped=true&"
import script from "./fontsDialog.vue?vue&type=script&lang=js&"
export * from "./fontsDialog.vue?vue&type=script&lang=js&"
import style0 from "./fontsDialog.vue?vue&type=style&index=0&id=4de79b12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de79b12",
  null
  
)

export default component.exports